"use client";

import { useNavigationTool, useContactPersonsListTool } from "./tools";

/**
 * Registers the always-available WebMCP tools (navigation) once for the app.
 * Mount once (see the root layout). Feature-specific tools — newsletter, forms —
 * register from their own components via the hooks in ./tools, using the same
 * `useMcpTool` primitive. To add a new global tool: write a `useXTool()` hook in
 * ./tools and call it here.
 */
export function WebMcpProvider() {
  useNavigationTool();
  useContactPersonsListTool();
  return null;
}
